import { logger } from "../util/Logger";
import { Command } from "./Command";

export class MultipleCommands implements Command {
  private _commands: Command[];

  constructor(command: Command[]) {
    this._commands = [...command];
  }

  ref(): object | undefined | void {
    logger.debug("Method not implemented.");
  }

  action(): void {
    throw new Error("Method not implemented.");
  }

  do(): void {
    this._commands.forEach((c, i) => c.do());
  }

  undo(): void {
    for (let i = this._commands.length; i > 0; i--)
      this._commands[i - 1].undo();
  }
  release(): void {
    for (let i = this._commands.length; i > 0; i--)
      this._commands[i - 1].release();
  }
}
